import React, { useCallback, useState } from 'react';
import { Box, Stack, Typography } from 'common/components/material';
import { useTheme } from '@mui/material';
import { SkillEndorsementButtons } from 'features/matching-engine/components/SkillEndorsementButtons';
import { VoteType } from 'features/matching-engine/matching-engine.utils';
import { useAddSkillFeedback } from 'features/matching-engine/hooks/useAddSkillFeedback';
import { Skill } from 'features/skills';
import { AddFeedbackText } from '../AddFeedbackText';

export const EndorsementSection: React.FC<{
  revieweeId: string;
  skill: Skill;
  groupId?: string;
  onSubmit?: () => void;
}> = ({ revieweeId, skill, groupId, onSubmit = () => {} }) => {
  const { palette } = useTheme();
  const [voteType, setVoteType] = useState<VoteType | null>(null);
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [feedbackText, setFeedbackText] = useState('');
  const { mutateAsync: addSkillFeedback } = useAddSkillFeedback(groupId);
  const handleSubmit = useCallback(async () => {
    if (!voteType) return;
    setIsDisabled(true);
    await addSkillFeedback({
      revieweeId,
      voteType,
      feedback: feedbackText,
      skillId: skill.id,
    });
    onSubmit();
    setVoteType(voteType);
    handleClear();
    setIsDisabled(false);
  }, [voteType, feedbackText, skill.id, revieweeId, addSkillFeedback]);

  const handleClear = () => {
    setFeedbackText('');
    setVoteType(null);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={2}
      sx={{ backgroundColor: palette.Card.Bg }}
    >
      <Typography variant="body3" fontWeight={600}>
        Your Endorsement
      </Typography>
      <Stack direction="row" spacing={2}>
        <SkillEndorsementButtons
          value={voteType}
          onSelect={setVoteType}
          isDisabled={isDisabled}
        />
        <AddFeedbackText
          handleSubmit={handleSubmit}
          currentVoteType={voteType}
          feedbackText={feedbackText}
          onChange={setFeedbackText}
          isDisabled={isDisabled}
          handleClear={handleClear}
        />
      </Stack>
    </Box>
  );
};
